export default () => ({
  socialAuth: null
})
